import * as ActionTypes from '../ActionTypes'
import * as RestURI from '../../shared/RestURI';
import {awsConfig} from '../../shared/config';

import {addToBucket} from './ActionCreatorsBucket';
import * as AuthC from '../../utils/auth/AuthCognito';



const rsvtiOperatorsLoading = (loadCriteria) => ({
    type: ActionTypes.RSVTI_OPERATORS_LOADING,
    payload: loadCriteria
});


const addRsvtiOperators = (operators) => ({
    type: ActionTypes.ADD_RSVTI_OPERATORS,
    payload: operators
});

const rsvtiOperatorsFailed = (errmess) => ({
    type: ActionTypes.RSVTI_OPERATORS_FAILED,
    payload: errmess
});


export const fetchRsvtiOperators = (clientId, worksiteId) => (dispatch) => {

    if(!clientId)
        return;

    const params = {
        functionName: 'getRsvtiOperators',
        clientId: clientId,
        worksiteId: worksiteId
    };

    const urlParams = new URLSearchParams(params);
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.QUERY}?${urlParams}`);

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    dispatch(rsvtiOperatorsLoading({clientId: clientId, worksiteId: worksiteId}));

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json())
        .then(subcons => dispatch(addRsvtiOperators(subcons)))
        .catch(error => {
            dispatch(rsvtiOperatorsFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Operatorilor RSVTI" } }));
        });
}
